var quickPurchaseBtns = document.querySelectorAll('.quick-purchase'),
    isSafariBrowser = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    
if (quickPurchaseBtns.length > 0) {
    quickPurchaseBtns.forEach(quickPurchaseBtn => {
        quickPurchaseBtn.removeAttribute('disabled');
        quickPurchaseBtn.addEventListener('click', function(e) {
            e.preventDefault();
            var form = quickPurchaseBtn.closest('form') || quickPurchaseBtn.closest('.footbar-product__controls');
            var quantityInput = form ? form.querySelector('input[type="number"][name="quantity"]') : null;
            var quantity = quantityInput ? quantityInput.value : 1;
            var href = quickPurchaseBtn.getAttribute('href');  
            var productHandle= document.querySelector('.product-page-main[data-product-handle]').getAttribute('data-product-handle');
             fetch(`${window.location.origin}/products/${productHandle}?section_id=cart-attributes-by-now&quantity=`+quantity).then(response => {return response.text();})
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const cartAttributes = doc.querySelector('#buy-now-attributes').value;          
                href = href.replace(/:[0-9]+$/, '');            
                var targetUrl = href + ':' + quantity;
                targetUrl += cartAttributes;
                if (isSafariBrowser) {
                    targetUrl += '&attributes[ios]=true';
                }
                window.location.href = targetUrl;
            });
        });
    });
}
